import React, { useState } from 'react';
import { Card, Form, Input, Select, Upload as AntUpload, Button, message, Steps } from 'antd';
import { UploadOutlined, FileTextOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { skillsApi } from '../services/api';

const { TextArea } = Input;
const { Option } = Select;
const { Step } = Steps;

const categories = [
  { code: 'creation', name: '创作分类' },
  { code: 'distribution', name: '发行分类' },
  { code: 'marketing', name: '营销分类' },
  { code: 'data', name: '数据分类' },
  { code: 'general', name: '工具通用' },
  { code: 'other', name: '其他工具' },
];

function UploadPage() {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [uploading, setUploading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setUploading(true);
      await skillsApi.createSkill(values);
      message.success('技能上传成功，等待审核');
      setCurrentStep(2);
    } catch (error) {
      message.error('上传失败');
    } finally {
      setUploading(false);
    }
  };

  const steps = [
    {
      title: '填写信息',
      content: (
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ maxWidth: 600, margin: '0 auto' }}
        >
          <Form.Item
            label="技能名称"
            name="displayName"
            rules={[{ required: true, message: '请输入技能名称' }]}
          >
            <Input placeholder="例如：歌词生成助手" />
          </Form.Item>

          <Form.Item
            label="技能标识"
            name="name"
            rules={[{ required: true, message: '请输入技能标识' }]}
          >
            <Input placeholder="例如：music-lyrics-generator" />
          </Form.Item>

          <Form.Item
            label="分类"
            name="category"
            rules={[{ required: true, message: '请选择分类' }]}
          >
            <Select placeholder="选择分类">
              {categories.map((cat) => (
                <Option key={cat.code} value={cat.code}>{cat.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="版本号"
            name="version"
            initialValue="1.0.0"
            rules={[{ required: true, message: '请输入版本号' }]}
          >
            <Input placeholder="例如：1.0.0" />
          </Form.Item>

          <Form.Item
            label="功能描述"
            name="description"
            rules={[{ required: true, message: '请输入功能描述' }]}
          >
            <TextArea rows={4} placeholder="描述该技能的功能和使用场景" />
          </Form.Item>

          <Form.Item
            label="安装指南"
            name="installGuide"
            rules={[{ required: true, message: '请输入安装指南' }]}
          >
            <TextArea rows={3} placeholder="```bash\nopenclaw skills install xxx\n```" />
          </Form.Item>

          <Form.Item
            label="使用示例"
            name="usageExample"
            rules={[{ required: true, message: '请输入使用示例' }]}
          >
            <TextArea rows={4} placeholder="```javascript\nconst result = await skill.xxx()\n```" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={uploading} block size="large">
              提交审核
            </Button>
          </Form.Item>
        </Form>
      ),
    },
    {
      title: '上传文件',
      content: (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <AntUpload.Dragger
            name="file"
            multiple={false}
            action="/api/upload/skill"
            onChange={(info) => {
              const { status } = info.file;
              if (status === 'done') {
                message.success(`${info.file.name} 上传成功`);
              } else if (status === 'error') {
                message.error(`${info.file.name} 上传失败`);
              }
            }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
            <p className="ant-upload-hint">
              支持 .zip, .tar.gz 格式的技能包
            </p>
          </AntUpload.Dragger>
        </div>
      ),
    },
    {
      title: '完成',
      content: (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <CheckCircleOutlined style={{ fontSize: 72, color: '#52c41a' }} />
          <h2 style={{ marginTop: 24 }}>上传成功！</h2>
          <p>您的技能已提交审核，审核通过后将上架到百音技能商店</p>
        </div>
      ),
    },
  ];

  return (
    <div>
      <h1 style={{ textAlign: 'center', marginBottom: 40 }}>上传技能</h1>
      <Card>
        <Steps current={currentStep} style={{ marginBottom: 40 }}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div>{steps[currentStep].content}</div>
      </Card>
    </div>
  );
}

export default UploadPage;
